/* og-concierge v2 "one tap" (Tom 21 Oct 2026: "if someone wants a live chat they have to click 3 buttons to do it").
   Config: window.__ogConcierge (snippets/og-concierge.liquid). No sheet any more:
   - Launcher pill = two targets. Main part (Tom's photo, page label, "Chat with Tom") opens Chatway straight onto a new
     conversation's composer (the snippet patches Chatway's widget config in-page: is_open_home_on_first_click=false,
     default_screen=chat_screen, so its "Start a new chat" home screen is skipped). WhatsApp segment = the prefilled wa.me link.
   - Proactive bubble carries the room check (sim / R50 / planning pages, with the free 3D plan line) or topic chips (cage).
     Chips open WhatsApp with the question prefilled (Chatway's composer can't be prefilled: cross-origin iframe; its
     sendMessage() would SEND, not pre-type). Room check results ride into WhatsApp's prefill and Chatway custom data.
   Chatway open = showChatwayIcon() then openChatwayWidget() (never hideChatwayIcon: it blocks open).
   Popups: the bubble and an open Chatway claim window.__ogModal {open,pending} (popup-coordinator).
   Events (gtag -> dataLayer; suppressed in test mode og_test / OGAgent): concierge_view, concierge_bubble{shown|dismiss},
   concierge_choice{livechat|whatsapp, source}, room_check_result{verdict}, concierge_topic, livechat_start.
   whatsapp_tap{location:'og-concierge'} is fired by og-gclid-capture. */
(function () {
  'use strict';
  var C = window.__ogConcierge;
  if (!C || window.OGConcierge) return;
  var doc = document, html = doc.documentElement;
  var SEG = C.seg || 'general';
  var ROOM = SEG === 'sim' || SEG === 'r50' || SEG === 'plan';
  var TEST = /(?:^|;\s*)og_test=1/.test(doc.cookie) || /OGAgent/.test(navigator.userAgent);
  var PHONE = function () { return window.innerWidth < 750; };
  var WA_PATH = 'M17.5 14.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.9 1.22 3.1.15.2 2.1 3.2 5.1 4.49.71.3 1.27.49 1.7.63.72.23 1.37.2 1.88.12.58-.09 1.76-.72 2-1.41.25-.7.25-1.29.18-1.41-.08-.13-.28-.2-.58-.35zM12.05 21.8h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88a9.83 9.83 0 0 1 7 2.9 9.83 9.83 0 0 1 2.89 7c0 5.45-4.44 9.88-9.9 9.88zm8.42-18.3A11.8 11.8 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.14 1.59 5.95L.07 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45c6.56 0 11.9-5.34 11.9-11.9 0-3.18-1.24-6.16-3.48-8.4z';
  var WA_ICO = function (s) { return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="' + WA_PATH + '"/></svg>'; };

  /* ---- page-type copy (Tom: name = "Tom" with his photo; no reply-time promise) ---- */
  var P = {
    sim:     { lbl: 'Will it fit?', bubble: 'Not sure it’ll fit your room? Ask us.', secs: 20, pct: 0.5 },
    r50:     { lbl: 'Will it fit?', bubble: 'Will the R50 fit your space? Ask us.', secs: 20, pct: 0.5 },
    cage:    { lbl: 'Questions about this cage?', bubble: 'Not sure which cage fits your garden? Ask us.', secs: 30, pct: 0.5,
               topics: ['Will it fit my garden?', 'Delivery', 'Does it need fixing down?', 'Which mat?'] },
    plan:    { lbl: 'Planning a sim?', bubble: 'Planning your own sim room? Ask us anything.', secs: 60, pct: 0.6 },
    cart:    { lbl: 'Help with your order?', bubble: null },
    general: { lbl: 'Questions?', bubble: null }
  };
  var p = P[SEG] || P.general;

  /* ---- tracking ---- */
  var EVLOG = window.__ogCcEvents = [];
  function ev(name, params) {
    var p2 = { segment: SEG, page_path: location.pathname };
    for (var k in params) p2[k] = params[k];
    EVLOG.push([name, p2]);
    if (TEST) return;
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, p2);
      else { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, p2)); }
    } catch (e) {}
  }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---- Chatway ---- */
  function cw() { try { return (window.$chatway && window.$chatway.isChatwayLoaded && window.$chatway.isChatwayLoaded()) ? window.$chatway : null; } catch (e) { return null; } }
  function cwOpen() { try { var c = cw(); return !!(c && c.isChatwayWidgetOpen && c.isChatwayWidgetOpen()); } catch (e) { return false; } }
  var online = false;
  window.addEventListener('message', function (e) {
    try {
      var d = e.data;
      if (!d || d.type !== 'CHATWAY' || d.action !== 'agent.status.change') return;
      var agents = typeof d.meta === 'string' ? JSON.parse(d.meta) : d.meta;
      online = Array.isArray(agents) && agents.some(function (a) { return a && a.attributes && String(a.attributes.online_status || '').toLowerCase() === 'online'; });
      root.classList.toggle('is-online', online);
    } catch (x) {}
  });

  /* ---- popup coordinator ---- */
  function modal() { var m = window.__ogModal; if (!m || typeof m !== 'object') { m = window.__ogModal = { open: false, pending: false }; } return m; }
  function busy() { var m = window.__ogModal; if (typeof m === 'string' && m) return true; return !!(m && (m.open || m.pending)); }
  var cwClaimed = false, wantLive = false;
  function cwSync() {
    var open = cwOpen();
    if (open && !cwClaimed) { cwClaimed = true; ssSet('ogcc_opened', '1'); var m = modal(); m.open = true; m.by = 'chatway'; }
    if (!open && cwClaimed) { cwClaimed = false; var m2 = modal(); if (m2.by === 'chatway') { m2.open = false; m2.pending = true; m2.by = ''; } }
    if (pill) pill.classList.toggle('is-gone', open);
    if (mini) mini.classList.toggle('is-gone', open);
    html.classList.toggle('ogcc-cw', open);
    if (open) hideBubble(false);
  }
  window.addEventListener('chatwayWidgetOpened', function () { cwSync(); if (wantLive) { wantLive = false; ev('livechat_start', { status: online ? 'online' : 'offline' }); } });
  window.addEventListener('chatwayWidgetClosed', cwSync);

  /* ---- room check (fixed rule; same numbers as og-room-gate / og-enc-fit / og-r50-fitcheck) ---- */
  var R = { w: null, l: null, h: null, topic: null };
  function verdict() {
    var w = R.w, l = R.l, h = R.h;
    if (w == null || l == null || h == null) return null;
    if (w >= 3.0 && h >= 2.7 && l >= 4.2) return { k: 'fits', head: 'Fits.', txt: 'Room for our standard bays.', short: 'fits' };
    if (w >= 3.56 && h >= 2.7 && l >= 2.8) return { k: 'sim0', cls: 'fits', head: 'Fits a SIM 0.', txt: 'The 1 m-deep bay for camera launch monitors.', short: 'fits a SIM 0 bay' };
    var s = []; if (w < 3.0) s.push('width'); if (h < 2.7) s.push('ceiling'); if (l < 4.2) s.push('length');
    return { k: 'tight', head: 'This might be tight,', txt: 'but let’s explore your options (' + s.join(', ') + ').', short: 'it might be tight' };
  }
  function f1(v) { return v == null ? '__' : (Math.round(v * 10) / 10).toFixed(1); }
  function hasRoom() { return R.w != null || R.l != null || R.h != null; }
  function msgFor(topic) {
    var nm = C.name ? String(C.name).trim() : '';
    if (topic) return 'Hi, I have a question' + (nm && SEG !== 'cart' ? ' about the ' + nm : '') + '. ' + topic;
    if (SEG === 'cart') return 'Hi, I need help with my order' + (C.items ? ' (' + C.items + ' in my basket)' : '') + '.';
    if (SEG === 'cage') return 'Hi, I have a question' + (nm ? ' about the ' + nm : '') + '.';
    if (SEG === 'general') return 'Hi, I have a question about a golf setup.';
    var lead = 'Hi, ' + (nm && SEG !== 'plan' ? 'I’m looking at the ' + nm + '. ' : '') + 'Will a sim fit my room?';
    if (!hasRoom()) return lead + ' It’s about (width x length x ceiling): ';
    var v = verdict();
    return lead + ' It’s about ' + f1(R.w) + ' x ' + f1(R.l) + ' m, ceiling ' + f1(R.h) + ' m.' + (v ? ' Room check said: ' + v.short + '.' : '');
  }
  function waUrl(text) { return 'https://wa.me/' + C.wa + '?text=' + encodeURIComponent(text); }

  /* ---- DOM ---- */
  var root = doc.createElement('div'); root.className = 'ogcc-root'; root.setAttribute('data-og-surface', 'og-concierge');
  var pill, chatBtn, waSeg, bubble, mini, bubbleShown = false, minimised = false;
  function av(cls) { return '<span class="ogcc-av ' + (cls || '') + '" style="background-image:url(' + esc(C.photo) + ')" aria-hidden="true"></span>'; }
  function roomHtml() {
    var inp = function (k, l) { return '<label class="ogcc-dim"><span>' + l + '</span><span class="ogcc-dimin"><input class="ogcc-num" data-ogcc-in="' + k + '" type="number" inputmode="decimal" step="0.1" min="1" max="20" placeholder="–" aria-label="' + l + ' in metres"><em>m</em></span></label>'; };
    return '<p class="ogcc-bsub">Send your room size: we’ll tell you straight if it fits, then draw you a free 3D plan of your room.</p>' +
      '<div class="ogcc-dims">' + inp('w', 'Width') + inp('l', 'Length') + inp('h', 'Ceiling') + '</div>' +
      '<div class="ogcc-v" data-ogcc-v aria-live="polite">Most rooms need 3.0 m wide × 4.2 m long × 2.7 m high.</div>';
  }
  function build() {
    root.innerHTML =
      '<button type="button" class="ogcc-mini" data-ogcc-restore aria-label="Show chat options" hidden>' + av('ogcc-dot') +
        '<span class="ogcc-badge" aria-hidden="true"><svg width="11" height="11" viewBox="0 0 24 24"><path fill="currentColor" d="M4 4h16a2 2 0 012 2v10a2 2 0 01-2 2H9l-5 4v-4a2 2 0 01-2-2V6a2 2 0 012-2z"/></svg></span></button>' +
      '<div class="ogcc-pill">' +
        '<button type="button" class="ogcc-min" data-ogcc-min aria-label="Minimise chat">\u00d7</button>' +
        '<button type="button" class="ogcc-chat" data-ogcc-chat aria-label="' + esc(p.lbl + ' Chat with an expert now (live chat)') + '">' + av('ogcc-dot') +
          '<span class="ogcc-lbl">' + esc(p.lbl) + '<small>Chat with an expert</small></span></button>' +
        '<a class="ogcc-waseg" data-ogcc-wa data-og-room-skip target="_blank" rel="noopener" href="' + esc(waUrl(msgFor())) + '" aria-label="Message on WhatsApp">' + WA_ICO(24) + '</a>' +
      '</div>' +
      (p.bubble ?
      '<div class="ogcc-bubble" role="dialog" aria-label="Question from our sim experts" hidden>' +
        '<button type="button" class="ogcc-x" data-ogcc-bx aria-label="Dismiss">×</button>' +
        '<div class="ogcc-bh">' + av('ogcc-sm') + '<div><b>OpenGolfer sim experts</b><span>Real person · no bots</span></div></div>' +
        '<p class="ogcc-bq">' + esc(p.bubble) + '</p>' +
        (ROOM ? roomHtml() :
          (p.topics ? '<div class="ogcc-chips">' + p.topics.map(function (t) { return '<a class="ogcc-chip" data-ogcc-topic="' + esc(t) + '" target="_blank" rel="noopener" href="' + esc(waUrl(msgFor(t))) + '">' + WA_ICO(15) + esc(t) + '</a>'; }).join('') + '</div><p class="ogcc-bsub">Tap a question to ask it on WhatsApp, or chat here.</p>' : '')) +
        '<div class="ogcc-bbtns"><button type="button" class="ogcc-cta" data-ogcc-bchat>Chat with an expert</button>' +
          '<a class="ogcc-cta ogcc-wa" data-ogcc-bwa target="_blank" rel="noopener" href="' + esc(waUrl(msgFor())) + '">' + WA_ICO(18) + ' Message on WhatsApp</a></div>' +
        '<a class="ogcc-email" data-ogcc-email href="/pages/contact-golf-net-specialists?topic=' + encodeURIComponent({cage:'cage',cart:'order',plan:'simulator',sim:'simulator',r50:'simulator',launch:'launch'}[SEG] || 'other') + (C.name ? '&product=' + encodeURIComponent(String(C.name).trim()) : '') + '" style="display:block;margin:10px 0 0;font-size:13px;font-weight:700;color:#2540E6;text-decoration:none">Prefer email? Send us a message &rarr;</a>' +
        '<p class="ogcc-note" data-ogcc-note hidden></p>' +
      '</div>' : '');
    doc.body.appendChild(root);
    pill = root.querySelector('.ogcc-pill'); chatBtn = root.querySelector('[data-ogcc-chat]'); waSeg = root.querySelector('[data-ogcc-wa]');
    bubble = root.querySelector('.ogcc-bubble'); mini = root.querySelector('.ogcc-mini');
  }
  /* og-room-gate (window capture) and og-gclid-capture (document capture) read the link BEFORE our listeners run,
     so every WhatsApp href and the room-skip flag are kept current on each change instead of at click time. */
  function syncWa() {
    var v = verdict();
    [waSeg, root.querySelector('[data-ogcc-bwa]')].forEach(function (a) {
      if (!a) return;
      a.href = waUrl(msgFor()); a.removeAttribute('data-og-tagged');
      /* launcher segment = one tap (Tom 21 Oct pm); its prefill already asks for width x length x ceiling. The bubble's button
         keeps the og-room-gate question unless the room was measured there. */
      if (v || a === waSeg) a.setAttribute('data-og-room-skip', ''); else a.removeAttribute('data-og-room-skip');
    });
  }
  var lastVerdict = null, roomT = null;
  function roomChanged() {
    var v = verdict(), box = root.querySelector('[data-ogcc-v]');
    if (box) { box.className = 'ogcc-v' + (v ? ' ' + (v.cls || v.k) : ''); box.innerHTML = v ? '<b>' + esc(v.head) + '</b> ' + esc(v.txt) : 'Most rooms need 3.0 m wide × 4.2 m long × 2.7 m high.'; }
    syncWa();
    clearTimeout(roomT);
    roomT = setTimeout(function () {
      var v2 = verdict();
      if (!v2 || v2.k === lastVerdict) return;
      lastVerdict = v2.k;
      var b = function (x) { return x < 2.5 ? '<2.5' : x < 2.7 ? '2.5-2.7' : x < 3 ? '2.7-3.0' : x < 3.6 ? '3.0-3.6' : x < 4.2 ? '3.6-4.2' : x < 5 ? '4.2-5.0' : '5.0+'; };
      ev('room_check_result', { verdict: v2.k, w: b(R.w), l: b(R.l), h: b(R.h) });
    }, 1200);
  }

  /* ---- minimise to a compact icon (Tom 21 Oct pm), remembered 7 days per visitor ---- */
  var MIN_KEY = 'og_cc_min';
  function minStored() { var t = +lsGet(MIN_KEY) || 0; return !!t && Date.now() - t < 7 * 864e5; }
  function setMin(on, user) {
    minimised = on;
    root.classList.toggle('is-min', on);
    if (mini) mini.hidden = !on;
    if (on) { lsSet(MIN_KEY, String(Date.now())); hideBubble(false); } else { try { localStorage.removeItem(MIN_KEY); } catch (e) {} }
    if (user) { ev(on ? 'concierge_minimise' : 'concierge_restore', {}); try { (on ? mini : chatBtn).focus({ preventScroll: true }); } catch (e) {} }
    place();
  }

  /* ---- live chat: one tap straight to the composer ---- */
  function startLive(source) {
    var v = verdict();
    ev('concierge_choice', { choice: 'livechat', placement: source || 'launcher', status: online ? 'online' : 'offline' });
    wantLive = true; hideBubble(false); ssSet('ogcc_opened', '1');
    var tries = 0;
    (function attempt() {
      var c = cw();
      if (c) {
        if (!TEST) {
          try { c.addChatwayTags(['concierge-' + SEG].concat(v ? ['room-' + v.k] : [])); } catch (e) {}
          try {
            c.updateChatwayCustomData('og_page', (C.name ? C.name + ' · ' : '') + location.pathname);
            if (hasRoom()) c.updateChatwayCustomData('og_room', f1(R.w) + ' x ' + f1(R.l) + ' m, ceiling ' + f1(R.h) + ' m' + (v ? ' (' + v.short + ')' : ''));
            var ref = window.__ogGetRef ? window.__ogGetRef() : ''; if (ref) c.updateChatwayCustomData('og_ref', ref);
          } catch (e) {}
        }
        try { if (c.showChatwayIcon) c.showChatwayIcon(); c.openChatwayWidget(); } catch (e) {}
        setTimeout(function () { cwSync(); if (!cwOpen()) failLive(); }, 1500);
        return;
      }
      if (tries++ < 20) return setTimeout(attempt, 300);
      failLive();
    })();
  }
  /* Chatway blocked / failed: say so and offer WhatsApp (never a dead tap) */
  function failLive() {
    wantLive = false;
    if (!bubble) { location.href = waUrl(msgFor()); return; }
    bubble.hidden = false; html.classList.add('ogcc-bubbling');
    var n = bubble.querySelector('[data-ogcc-note]'); n.textContent = 'Live chat didn’t load on this device. WhatsApp or call us on ' + C.telLabel + '.'; n.hidden = false;
  }

  /* ---- bubble ---- */
  var DAY = 864e5;
  function bubbleEligible() {
    if (!bubble || minimised) return false;
    if (ssGet('ogcc_opened') || ssGet('ogcc_bub')) return false;
    var last = +lsGet('ogcc_bub_' + SEG) || 0;
    return !(last && Date.now() - last < 14 * DAY);
  }
  function cookieBanner() { var b = doc.getElementById('shopify-pc__banner'); if (!b) return false; var cs = getComputedStyle(b), r = b.getBoundingClientRect(); return cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0; }
  function blocked() { return cwOpen() || busy() || cookieBanner() || pill.classList.contains('is-tucked') || doc.querySelector('.og-rg'); }
  function showBubble(force) {
    if (!bubble || (bubbleShown && !force)) return;
    if (!force && (!bubbleEligible() || blocked())) return;
    bubbleShown = true;
    var m = modal(); m.open = true; m.by = 'concierge-bubble';
    ssSet('ogcc_bub', '1'); lsSet('ogcc_bub_' + SEG, String(Date.now()));
    bubble.hidden = false; html.classList.add('ogcc-bubbling');
    ev('concierge_bubble', { action: 'shown' });
  }
  function hideBubble(dismissed) {
    if (!bubble || bubble.hidden) return;
    bubble.hidden = true; html.classList.remove('ogcc-bubbling');
    var m = modal(); if (m.by === 'concierge-bubble') { m.open = false; m.pending = true; m.by = ''; }
    if (dismissed) ev('concierge_bubble', { action: 'dismiss' });
  }
  function armBubble() {
    if (!bubbleEligible()) return;
    var t0 = Date.now(), due = false, iv;
    function check() {
      if (bubbleShown || !bubbleEligible()) return clearInterval(iv);
      if (!due) {
        var h = doc.documentElement, sp = window.scrollY / Math.max(1, h.scrollHeight - window.innerHeight);
        if ((Date.now() - t0) / 1000 >= p.secs || sp >= p.pct) due = true;
      }
      if (due) showBubble();
    }
    iv = setInterval(check, 1000);
    window.addEventListener('scroll', function () { if (!bubbleShown) check(); }, { passive: true });
  }

  /* ---- placement: above fixed bottom bars + the cookie bar; tucked on phones while a buy/checkout CTA would be covered ---- */
  /* + docs / Face-To-Path rail CTAs, which sit bottom-right on desktop (found 21 Oct: launcher covered 'Check my room on WhatsApp') */
  var CTA_SEL = '.ogd__fit .ogd__btn,.ogd__simon,.ogf__rail .ogf__btn,.r50xp__atc,.btn.add-to-cart,button[name="add"],[name="checkout"],.cart__checkout,shopify-accelerated-checkout,shopify-accelerated-checkout-cart,.additional-checkout-buttons,.og-hb-sticky__cta,.sb-cta,.sb-add-to-cart';
  function ours(el) { return root.contains(el); }
  function fixedBar(el) {
    for (var i = 0; el && el !== doc.body && i < 10; i++, el = el.parentElement) {
      var id = (el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '');
      if (/chatway|og-nudge|ogcc-/.test(id)) return null;
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed' || cs.position === 'sticky') {
        var r = el.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.45 && r.height < window.innerHeight * 0.6 && r.bottom >= window.innerHeight - 4) return r;
        return null;
      }
    }
    return null;
  }
  function place() {
    if (!pill) return;
    var H = window.innerHeight, W = window.innerWidth, lift = 0;
    [W - 20, W - 110, W - 200].forEach(function (x) {
      if (x < 4) return;
      var stack = doc.elementsFromPoint ? doc.elementsFromPoint(x, H - 6) : [];
      for (var i = 0; i < stack.length; i++) {
        if (ours(stack[i]) || stack[i] === doc.body || stack[i] === html) continue;
        var r = fixedBar(stack[i]);
        if (r) { lift = Math.max(lift, Math.round(H - r.top)); break; }
      }
    });
    var cb = doc.getElementById('shopify-pc__banner'), cbOn = !!(cb && cookieBanner());
    html.classList.toggle('ogcc-banner', cbOn);
    if (cbOn) { var cr = cb.getBoundingClientRect(); if (cr.top > H * 0.25 && cr.top < H) lift = Math.max(lift, Math.round(H - cr.top)); }
    root.style.setProperty('--lift', lift + 'px');
    var vis = minimised && mini ? mini : pill, lr = vis.getBoundingClientRect();
    html.style.setProperty('--og-cc-top', Math.round((PHONE() ? 16 : 24) + lift + (lr.height || 56)) + 'px');
    var tuck = false;
    if (!(bubble && !bubble.hidden)) {
      var off = PHONE() ? 16 : 24, side = PHONE() ? 14 : 24;
      var base = { top: H - off - lift - (lr.height || 56), bottom: H - off - lift, left: W - side - Math.max(lr.width, minimised ? 52 : 200), right: W - side };
      var els = doc.querySelectorAll(CTA_SEL);
      for (var j = 0; j < els.length && !tuck; j++) {
        if (ours(els[j])) continue;
        var r2 = els[j].getBoundingClientRect();
        if (!r2.width || !r2.height) continue;
        if (r2.bottom > base.top - 6 && r2.top < base.bottom + 6 && r2.right > base.left && r2.left < base.right) tuck = true;
      }
    }
    pill.classList.toggle('is-tucked', tuck && !minimised);
    if (mini) mini.classList.toggle('is-tucked', tuck && minimised);
  }
  var placeQueued = false;
  function queuePlace() { if (placeQueued) return; placeQueued = true; requestAnimationFrame(function () { placeQueued = false; place(); }); }

  /* ---- wire ---- */
  function wire() {
    chatBtn.addEventListener('click', function () { startLive('launcher'); });
    root.querySelector('[data-ogcc-min]').addEventListener('click', function (e) { e.stopPropagation(); setMin(true, true); });
    mini.addEventListener('click', function () { setMin(false, true); });
    /* WhatsApp taps: capture on our root (after the room gate + gclid tagger, which read the href we keep current) */
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-ogcc-wa],[data-ogcc-bwa],[data-ogcc-topic]');
      if (!a) return;
      if (verdict()) lsSet('og_room_ok', String(Date.now()));
      var topic = a.getAttribute('data-ogcc-topic');
      if (topic) ev('concierge_topic', { topic: topic });
      ev('concierge_choice', { choice: 'whatsapp', placement: a.hasAttribute('data-ogcc-wa') ? 'launcher' : (topic ? 'bubble_topic' : 'bubble'), status: online ? 'online' : 'offline' });
      setTimeout(function () { hideBubble(false); }, 300);
    }, true);
    if (bubble) {
      bubble.querySelector('[data-ogcc-bx]').addEventListener('click', function () { hideBubble(true); });
      bubble.querySelector('[data-ogcc-bchat]').addEventListener('click', function () { startLive('bubble'); });
      bubble.querySelectorAll('[data-ogcc-in]').forEach(function (i) {
        i.addEventListener('input', function () {
          var k = i.getAttribute('data-ogcc-in'), v = parseFloat(String(i.value).replace(',', '.'));
          R[k] = isFinite(v) && v > 0 ? Math.min(20, v) : null; roomChanged();
        });
      });
    }
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideBubble(true); });
    window.addEventListener('scroll', queuePlace, { passive: true });
    window.addEventListener('resize', queuePlace);
    setInterval(function () { place(); cwSync(); }, 1000);
  }

  /* ---- public API: page CTAs ("Ask Tom" cards, former SIM:ON buttons) open live chat in one tap ---- */
  window.OGConcierge = {
    mounted: false,
    open: function (source) { if (this.mounted) startLive(source || 'cta'); else location.href = '/pages/golf-simulator-room-design'; return false; },
    /* a measured room (e.g. the R50 fit check) travels into Chatway custom data + the WhatsApp prefill */
    openWith: function (o) {
      o = o || {};
      ['w', 'l', 'h'].forEach(function (k) { var v = parseFloat(o[k]); if (isFinite(v) && v > 0) R[k] = Math.min(20, v); });
      if (this.mounted) { syncWa(); startLive(o.source || 'cta'); } else location.href = '/pages/golf-simulator-room-design';
      return false;
    },
    whatsapp: function () { return waUrl(msgFor()); },
    showBubble: function () { showBubble(true); },
    state: function () { return { minimised: minimised, seg: SEG, online: online, room: { w: R.w, l: R.l, h: R.h }, verdict: verdict(), bubbleShown: bubbleShown, wa: waSeg && waSeg.href }; }
  };
  doc.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-og-concierge-open],[data-simon-open],a[href="/pages/sim-on"],a[href^="/pages/sim-on?"],a[href^="/pages/sim-on#"],a[href="https://www.opengolfer.co.uk/pages/sim-on"]');
    if (!a || ours(a) || !window.OGConcierge.mounted) return;
    e.preventDefault(); e.stopPropagation();
    startLive(a.getAttribute('data-og-concierge-open') || 'page_cta');
  }, true);

  function mount() {
    build(); wire();
    if (minStored()) setMin(true, false);
    window.OGConcierge.mounted = true;
    html.classList.add('og-cc-on');
    place();
    ev('concierge_view', {});
    armBubble();
    try { doc.dispatchEvent(new CustomEvent('og:concierge-ready')); } catch (e) {}
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', mount); else mount();
})();
